import { render, staticRenderFns } from "./OrgListing.vue?vue&type=template&id=0ba958fa&scoped=true&"
import script from "./OrgListing.vue?vue&type=script&lang=js&"
export * from "./OrgListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba958fa",
  null
  
)

export default component.exports